module.exports = __webpack_public_path__ + "static/img/wechat_demo.1387678e.png";